import React from "react";

export const Loader = () => (
  <div className="text-center">
    <div className="spinner-border">
      <span className="sr-only">Loading ...</span>
    </div>
  </div>
);
